import sodium from 'libsodium-wrappers';

class CryptoService {
  async init() {
    await sodium.ready;
    this.sodium = sodium;
  }

  generateKeyPair() {
    const keyPair = this.sodium.crypto_box_keypair();

    return {
      publicKey: this.sodium.to_base64(keyPair.publicKey),
      privateKey: this.sodium.to_base64(keyPair.privateKey),
    };
  }

  async saveKeys(keyId, publicKey, privateKey) {
  const allKeys = JSON.parse(
    localStorage.getItem("e2ee_keys") || "{}"
  );

  allKeys[keyId] = {
    publicKey,
    privateKey,
  };

  localStorage.setItem(
    "e2ee_keys",
    JSON.stringify(allKeys)
  );

  localStorage.setItem(
    "active_key_id",
    String(keyId)
  );

  // Compatibilité temporaire
  localStorage.setItem("publicKey", publicKey);
  localStorage.setItem("privateKey", privateKey);
}

async getKeys() {
  const activeKeyId =
    localStorage.getItem("active_key_id");

  const allKeys = JSON.parse(
    localStorage.getItem("e2ee_keys") || "{}"
  );

  if (
    activeKeyId &&
    allKeys[activeKeyId]
  ) {
    return {
      keyId: Number(activeKeyId),
      publicKey: allKeys[activeKeyId].publicKey,
      privateKey: allKeys[activeKeyId].privateKey,
    };
  }

  // Compatibilité avec les anciennes installations
  return {
    keyId: null,
    publicKey: localStorage.getItem("publicKey"),
    privateKey: localStorage.getItem("privateKey"),
  };
}

async getPrivateKeyById(keyId) {
  const allKeys = JSON.parse(
    localStorage.getItem("e2ee_keys") || "{}"
  );

  return allKeys[keyId]?.privateKey || null;
}
  encryptMessage(message, recipientPublicKey, senderPrivateKey) {
    const nonce = this.sodium.randombytes_buf(
      this.sodium.crypto_box_NONCEBYTES
    );

    const encrypted = this.sodium.crypto_box_easy(
      message,
      nonce,
      this.sodium.from_base64(recipientPublicKey),
      this.sodium.from_base64(senderPrivateKey)
    );

    return {
      encrypted: this.sodium.to_base64(encrypted),
      nonce: this.sodium.to_base64(nonce),
    };
  }

  decryptMessage(encrypted, nonce, senderPublicKey, recipientPrivateKey) {
    const decrypted = this.sodium.crypto_box_open_easy(
      this.sodium.from_base64(encrypted),
      this.sodium.from_base64(nonce),
      this.sodium.from_base64(senderPublicKey),
      this.sodium.from_base64(recipientPrivateKey)
    );

    return this.sodium.to_string(decrypted);
  }
}

export default new CryptoService();